import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import React from 'react'
import AddIcon from '@mui/icons-material/Add'
import { useTranslation } from 'react-i18next'
import { getButtonTestId } from '../Buttons/getButtonTestId'

/** @notExported */
interface AddButtonProps {
  /** Action to perform when button is clicked. */
  clickAction: () => void
  /** Tooltip for button. */
  tooltip?: string
  /** Whether or not the button is valid. */
  valid?: boolean
  /** Size of the button. */
  size?: 'medium' | 'small' | undefined | 'xsmall'
  /** Test id of the button. */
  testId?: string
}

/**
 * Add button component.
 *
 * @returns Add button component.
 * @notExported
 * @category Buttons
 */
const AddButton: React.FC<AddButtonProps> = ({ clickAction, tooltip, valid = true, size, testId }) => {
  const { t } = useTranslation()
  const label = tooltip ?? (t('add') as string)
  const resolvedTestId = getButtonTestId({ fallback: 'button-add-icon', label, testId })

  const getButton = () => {
    return (
      <span style={{ display: 'inline-flex', float: 'right' }}>
        <IconButton
          data-testid={resolvedTestId}
          aria-label={label}
          onClick={() => clickAction()}
          disabled={!valid}
          size={size === 'xsmall' ? 'medium' : size}
        >
          <AddIcon fontSize={size === 'xsmall' ? 'small' : 'large'} />
        </IconButton>
      </span>
    )
  }

  return (
    <Tooltip title={label} describeChild>
      {getButton()}
    </Tooltip>
  )
}

export default AddButton
